import { AuthActionType, AuthErrorCode } from '../enums';

export const AUTH_ERROR_MESSAGES_MAP = new Map<
  AuthErrorCode,
  Map<AuthActionType, string>
>([
  [
    AuthErrorCode.NotAllowedException,
    new Map([
      [
        AuthActionType.SignIn,
        'auth.sign_in.errors.not_allowed',
      ],
    ]),
  ],
  [
    AuthErrorCode.NotAuthorizedException,
    new Map([
      [
        AuthActionType.SignIn,
        'auth.sign_in.errors.not_authorised',
      ],
    ]),
  ],
  [
    AuthErrorCode.UserDisabledException,
    new Map([
      [
        AuthActionType.ForgotPassword,
        'auth.forgot_password.errors.user_disabled',
      ],
      [
        AuthActionType.SignIn,
        'auth.sign_in.errors.user_disabled',
      ],
    ]),
  ],
  [
    AuthErrorCode.UserNotFoundException,
    new Map([
      [
        AuthActionType.ForgotPassword,
        'auth.forgot_password.errors.user_not_found',
      ],
      [
        AuthActionType.SignIn,
        'auth.sign_in.errors.user_not_found',
      ],
    ]),
  ],
  [
    AuthErrorCode.Unknown,
    new Map([
      [
        AuthActionType.ForgotPassword,
        'auth.forgot_password.errors.unknown',
      ],
      [
        AuthActionType.SignIn,
        'auth.sign_in.errors.unknown',
      ],
      [
        AuthActionType.SignOut,
        'auth.sign_out.errors.unknown',
      ],
    ]),
  ],
]);

export const DEFAULT_AUTH_ERROR_MESSAGE = 'auth.shared.errors.api';
